import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';
import router from '@/router';
import { useUserStore } from './UserStore';

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        user: useUserStore().user,
        returnUrl: '/community/feed'
    }),
    actions: {
        async login (username, password) {
            // get user from service using token
            const _token = await ApiService.login(username, password);
            // update pinia state
            this.token = _token.data.access_token;
            ApiService.setToken(this.token);
            // redirect to previous url or default to home page
            // router.push('/');
        },
        async getUser () {
            await ApiService.getUser().then(async (usr) => {
                this.user = usr.data;
                this.user.token = ApiService.token;
                const subs = await ApiService.getUserSubscriptions();
                this.user.subscriptions = subs.data;
            });

            const userStore = useUserStore();
            userStore.user = this.user;
            // store user details and jwt in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(this.user));
            router.push('/community/feed');
        },
        logout () {
            this.user = null;
            localStorage.removeItem('user');
            router.push('/login');
        }
    }
});